/**
 * The Rob State view.
 * Handles all rendering and event bindings in the ROB page.
 */

var VRC = VRC || {};
VRC.RobStateView = (function () {
	var $el;

	var init = function () {
		$el = $('#rob-state');

		var robRows = VRC.RobManager.toJson();

		render(robRows);
		attachEvents($el);
	};

	var render = function (robRows) {
		var fuelTanks = VRC.BulkTankManager.getConsumable();
		fuelTanks = _.map(fuelTanks, function (fuelTank) {
			return fuelTank.toJson()
		});

		fuelTanks = _.sortBy(fuelTanks, function (fuelTank) {
			return fuelTank.consumableSeqNo
		});

		var ctx = {
			fuelTanks: fuelTanks,
			robRows: robRows
		};

		$el.html(WELL.Handlebars.VRC['rob_state'](ctx));
	};

	var attachEvents = function ($el) {
		attachDateChange($el.find('.rob-state__date'));
		attachRemarksChange($el.find('.rob-state__remarks'));
		attachRobChange($el.find('.rob-state__robQty'));
		attachAvailableForDeliveryChange($el.find('.available-for-delivery'));
		attachAddRow($el.find('.rob-state__addBtn'));
		attachRemoveRow($el.find('.rob-state__removeBtn'));
        attachDocumentsButton($('.rob-fuelDocumentsBtn'));
        attachROBValidationButton($('.rob-robValidationBtn'));
	};

	var attachAddRow = function ($elements) {
		$elements.click(function (e) {
			e.preventDefault();
			var $btn = $(this);

			var row = VRC.RobManager.getLastestRow();
			var date;
			if (row) {
				date = moment(row.getDate(), g_timeStampFormat);

			}
			else {
				date = moment();
			}
			date.add(1, 'days');
			date.endOf('day');
			var newRow = VRC.RobManager.addNewRob(date);
			var $html = $(Handlebars.partials['rob_row'](newRow.toJson()));
			attachEvents($html);
			var $row = $btn.closest('tr');
			$html.insertAfter($row)

		});
	};

	var attachRemoveRow = function ($elements) {
		$elements.click(function (e) {
			e.preventDefault();
			var $btn = $(this);
			var date = getDateValue($btn);

			VRC.RobManager.removeRow(date);

			var $row = $btn.closest('tr');
			$row.remove();
		});
	};

	var updateRobQty = function (voyageBulk, qty) {
		voyageBulk.setQtyRob(qty);
		voyageBulk.setValueQty(qty);
	};

	var addVoyageBulk = function (bulkTankId, date, qty, robRow) {
		robRow.addVoyageBulk(bulkTankId, date, qty)
	};
	var removeVoyageBulk = function (bulkTankId, robRow) {
		robRow.removeVoyageBulk(bulkTankId);
	};

	var isBlank = function (str) {
		return (!str || /^\s*$/.test(str));
	};

	var attachRobChange = function ($elements) {
		var backupValue;
		$elements.on('focus', function () {

			backupValue = $(this).val();

		});
		$elements.change(function () {
			var $robField = $(this);

			var bulkTankId = $robField.attr('data-bulktank-id');
			var date = getDateValue($robField);
			var robRow = VRC.RobManager.getRow(date);
			var entry = robRow.getEntryByBulkTankId(bulkTankId);

			var qty = $robField.val();

			if (!isBlank(qty)) {
				qty = VRC.Utils.Number.parseFloat(qty);

				if (qty && qty >= 0) {
					if (robRow.hasVoyageBulk(entry)) {
						updateRobQty(entry, qty);
					}
					else {
						addVoyageBulk(bulkTankId, date, qty, robRow);
					}
				}
				else {
					$robField.val(backupValue);
				}
			}
			else {
				removeVoyageBulk(bulkTankId, robRow)
			}

		})
	};

	var findRow = function ($inputElement) {
		return $inputElement.closest('tr');
	};

	var isValid = function (date) {

		return moment(date, g_timeStampFormat, true).isValid()
	};

	var getDateValue = function ($inputElement) {

		var $row = findRow($inputElement);
		var $dateField = $row.find('.rob-state__date');
		return $dateField.val();
	};

	var attachRemarksChange = function ($elements) {

		$elements.change(function () {
			var $remarkField = $(this);
			var date = getDateValue($remarkField);
			var robRow = VRC.RobManager.getRow(date);
			robRow.setRemarks($remarkField.val());
		});
	};

	var attachDateChange = function ($elements) {

		var backupDate;
		$elements.datetimepicker(
			{
				format: g_timeStampFormat
			});
		$elements.on('focus', function () {
			backupDate = $(this).val();

		});

		$elements.on('dp.hide', function () {

			var robRow = VRC.RobManager.getRow(backupDate);

			var date = $(this).val();
			if (VRC.RobManager.hasDate(date)) {

				if (date !== backupDate) {
					$(this).val(backupDate);
				}
			}
			else {
				if (!isBlank(date) && isValid(date)) {

					robRow ? robRow.setDate(date) : VRC.RobManager.addNewRob(moment(date, g_timeStampFormat));
					VRC.RobManager.updateIndex(backupDate, date);
				}
				else {
					$(this).val(backupDate);
				}
			}
		});
	};
    
    var attachDocumentsButton = function($elements) {
        $elements.click(function (e) {
			e.preventDefault();
            
            g_remote_object.FetchHTMLFromServer( g_bulk_planning, ParseWELSForm, 'info', 'rob_documents');
        });
    };

    var attachROBValidationButton = function($elements) {
    	$elements.click(function(e) {
            e.preventDefault();

            g_remote_object.FetchHTMLFromServer( g_bulk_planning, ParseWELSForm, 'info', 'rob_validation');
		});
	};

    var attachAvailableForDeliveryChange = function ($elements) {
        var backupValue;
        $elements.on('focus', function () {
            backupValue = $(this).val();
        });

        $elements.change(function () {
            var $afdField = $(this);
            var newFieldValue = $afdField.val();

            if (newFieldValue >= 0) {
                var bulkTankId = $afdField.attr('data-bulktank-id');
                var bulkTank = VRC.BulkTankManager.getBulkTankById(bulkTankId);
                bulkTank.setAvailableForDelivery(newFieldValue);
            }
            else {
                $(this).val(backupValue);
			}
		});
    };

	return {
		init: init
	}
})();


